import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, TextInput } from "flowbite-react"
import { HiOutlineBookOpen, HiOutlineArrowNarrowRight, HiOutlineArrowNarrowLeft, HiOutlineSearch } from "react-icons/hi";
import { removeAllProductInCart } from '../redux/locationReducer';
import { getAllMenu, addProductToMenus, removeAllSelectedMenusOfCart } from '../redux/menuReducer';
// import CartItem from "./Global/CartItem";
import swal from 'sweetalert2';
import { openSnackBar } from '../redux/snackBarReducer';
import MenuItem from "../components/Global/MenuItem"
import NewMenuFromCart from "./Global/NewMenuFromCart";
import { useTranslation } from "react-i18next";

function AddProductInToWineMenu(props) {
    const { t } = useTranslation();
    const { globalState, locationState, menuState } = useSelector((state) => state);

    const { carts } = locationState;
    const { condition } = globalState;
    const { selectedMenusOfCart, menus } = menuState;

    const dispatch = useDispatch();

    useEffect(() => {
        if (condition.company) {
            dispatch(getAllMenu({
                search: "", isGlobal: condition.isGlobal,
                company: condition.company, role: condition.role, user_id: condition.user_id
            }));
        }
    }, [condition])

    const [modalShow, setModalShow] = useState(false);
    const [search, setSearch] = useState("");

    const changeSearch = (e) => {
        setSearch(e.target.value);

        dispatch(getAllMenu({
            search: e.target.value, isGlobal: condition.isGlobal,
            company: condition.company, role: condition.role, user_id: condition.user_id
        }));
    }

    const addProductToSelectedMenus = async () => {
        if (selectedMenusOfCart?.length > 0) {
            let sentProduct = [];
            carts.map(cart => {
                sentProduct = [...sentProduct, { product: cart._id, product_type: cart.product_type._id, category: cart.category, sub_category: cart.sub_category }]
            });

            swal.fire({
                title: t("swal_are_you_sure"),
                text: t("swal_duplicate_product_menu"),
                icon: "warning",
                showDenyButton: true,
                showCancelButton: true,
                denyButtonText: t("swal_no_duplicate"),
                confirmButtonText: t("swal_duplicate")
            })
                .then(async result => {
                    let res;
                    if (result.isConfirmed) {
                        res = await dispatch(addProductToMenus({ menus: selectedMenusOfCart, products: sentProduct, isDuplicate: true }));
                    } else if (result.isDenied) {
                        res = await dispatch(addProductToMenus({ menus: selectedMenusOfCart, products: sentProduct, isDuplicate: false }));
                    }

                    if (res?.status === "success") {
                        dispatch(openSnackBar({ message: t("msg_success_add_product_menu"), status: 'success' }));
                        // navigate('/menuedit');
                        dispatch(removeAllProductInCart("not alert"));
                        dispatch(removeAllSelectedMenusOfCart());

                        setModalShow(false);
                        props.closePrevModal(false);
                    }
                });


        } else {
            dispatch(openSnackBar({ status: "error", message: "There is no selected menu." }));
        }
    }

    const openModal = () => {
        if (carts.length > 0) {
            setModalShow(true)
        } else {
            dispatch(openSnackBar({ status: "error", message: "There is no product in basket." }));
        }
    }

    return (

        <>
            <div className="">
                <Button className="bg-indigo-500 text-white hover:!bg-indigo-400" color='red'
                    onClick={() => openModal()}
                >
                    {t("add_to_wine_menu")}
                    {/* <HiOutlineBookOpen className="ml-2 h-5 w-5" /> */}
                    <svg viewBox="0 0 24 24" className="ml-2 h-5 w-5"  xmlns="http://www.w3.org/2000/svg" stroke-width="1.5">
                        <path d="M16.5,21.513a1.5,1.5,0,0,1-1.9,1.446L4.1,20.042A1.5,1.5,0,0,1,3,18.6V2.487A1.5,1.5,0,0,1,4.9,1.041L15.4,4.432a1.5,1.5,0,0,1,1.1,1.445Z" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.5.987h15a1.5,1.5,0,0,1,1.5,1.5v15.75a1.5,1.5,0,0,1-1.5,1.5h-3" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </Button>
            </div>
            <Modal
                show={modalShow}
                size="4xl"
                popup={true}
                onClose={() => setModalShow(false)}
            >
                <Modal.Header className="py-4 ml-3 mr-3">
                    {t("add_products_into_wine_menu")}
                </Modal.Header>
                <hr />
                <Modal.Body>
                    <div className="py-6">
                        <NewMenuFromCart closePrevModal={setModalShow} closeParentModal={props.closePrevModal} />
                        <div className="py-2">
                            <TextInput
                                id="searchproduct"
                                type="search"
                                className="w-full"
                                placeholder={t("search_your_existing_wine_menu")}
                                required={true}
                                icon={HiOutlineSearch}
                                value={search}
                                onChange={(e) => changeSearch(e)}
                            />
                        </div>
                        <div className="max-h-96 overflow-auto">
                            {
                                menus?.length > 0 ? menus.map((data, index) =>
                                    <MenuItem key={index} data={data} />
                                ) : t("nodata")
                            }
                        </div>
                    </div>
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex justify-center m-auto gap-4">
                        <Button
                            onClick={() => setModalShow(false)}
                        >
                            {/* <HiOutlineArrowNarrowLeft className="mr-2 h-5 w-5" /> */}
                            <svg  className="mr-2 h-5 w-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5">
                                <path d="M16.25,23.25,5.53,12.53a.749.749,0,0,1,0-1.06L16.25.75" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            {t("back_to_basket")}
                        </Button>
                        <Button
                            onClick={() => addProductToSelectedMenus()}
                            disabled={selectedMenusOfCart.length > 0 ? false : true}
                        >
                            {t("add_to_selected_wine_menus")}
                            {/* <HiOutlineArrowNarrowRight className="ml-2 h-5 w-5" /> */}
                            <svg viewBox="0 0 24 24" className="ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5">
                                <path d="M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.25 14.25L17.25 20.25" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.25 17.25L20.25 17.25" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.25,20.25h-6a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75H12.879a1.5,1.5,0,0,1,1.06.439l2.872,2.872a1.5,1.5,0,0,1,.439,1.06V8.25" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddProductInToWineMenu;
